import { Directive, HostListener, inject, input, ElementRef } from '@angular/core';
import { MixpanelService } from '@app/core/infrastructure/analytics';

@Directive({
  selector: '[appMixpanelClick]',
  standalone: true
})
export class MixpanelClickDirective {
  private readonly mixpanel = inject(MixpanelService);
  private readonly element = inject(ElementRef);
  readonly eventName = input<string>();
  readonly category = input<string>();

  @HostListener('click', ['$event'])
  handleClick(event: MouseEvent): void {
    if (event.defaultPrevented) return;
    const targetEl = (event.target as HTMLElement);
    const el = targetEl.hasAttribute('data-mp') ? targetEl : targetEl.closest('[data-mp]') || this.element.nativeElement;
    if (!el.hasAttribute('data-mp') && !this.eventName()) return;
    const name = this.eventName() || el.getAttribute('data-mp');
    if (!name) return;
    const label = el.getAttribute('data-mp-label') || el.textContent?.trim() || '';
    const category = this.category() || el.getAttribute('data-mp-category') || 'general';
    const additionalProps = this.parseAdditionalProps(el);
    const elementProps = {
      label,
      category,
      elementId: el.id || '',
      elementType: el.tagName.toLowerCase(),
      timestamp: new Date().toISOString()
    };

    this.mixpanel.track(name!, {
      ...elementProps,
      ...additionalProps
    });
  }

  private parseAdditionalProps(element: HTMLElement): Record<string, string | number | boolean> {
    const propsAttr = element.getAttribute('data-mp-props');
    if (!propsAttr) return {};

    try {
      return JSON.parse(propsAttr);
    } catch (e) {
      console.warn('Error parsing data-mp-props attribute:', e);
      return {};
    }
  }
}
